import { $, addAction, INIT } from '@situation/setdesign.util';

addAction(INIT, () => {
    $('.button--primary, .header-nav__cta .button').each(() => {
        const $button = $(this);
        const randNum = Math.floor(Math.random() * 5000);
        setTimeout(() => {
            $button.addClass('button--sparkle');
        }, randNum);
    });
});
